import { api } from "@/lib/api";
import { openReceiptPrint, downloadReceipt } from "@/lib/receipt";
import { businessHeader } from "@/lib/outlet";

function enrichInvoice(invoice, customerFallback) {
    if (invoice.customer?.full_name) return invoice;
    if (!customerFallback) return invoice;
    return {
        ...invoice,
        customer: {
            full_name: customerFallback.full_name,
            mobile: customerFallback.mobile,
        },
    };
}

export async function fetchInvoiceReceipt(invoiceId) {
    const { data } = await api.get(`/invoices/${invoiceId}`);
    return data;
}

export async function printInvoiceById(invoiceId, { outlets, user, customerFallback } = {}) {
    const invoice = enrichInvoice(await fetchInvoiceReceipt(invoiceId), customerFallback);
    const business = businessHeader(outlets, user, invoice.outlet_id);
    return openReceiptPrint(invoice, business);
}

export async function downloadInvoiceById(invoiceId, { outlets, user, customerFallback } = {}) {
    const invoice = enrichInvoice(await fetchInvoiceReceipt(invoiceId), customerFallback);
    const business = businessHeader(outlets, user, invoice.outlet_id);
    downloadReceipt(invoice, business);
}
